import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"
import { sprintSsoUrl } from "../../utils/Helpers"

const SIRIUSXM_PROMO_CODE = "2023SIRIUSXMP1"

export const SiriusXmGetStartedComponent = (props) => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(SIRIUSXM_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({ disabled, handleClick }) => {
    return (
      <>
        <Button
          type="button"
          className="btn"
          primary
          disabled={disabled}
          onClick={() => {
            setSubmissionPromoCode(promoCode)
            handleClick()
          }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
        SIRIUSXM_PROMO_CODE
    )
  ]

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <div className="col"  dangerouslySetInnerHTML={{__html: props.firstSectionText}}/>
            <img style={{ marginTop: "1rem"}} src={"/images/SiriusXm/SiriusXM-horizontal-4C.png"} alt="Sirius XM Logo" className="mb-3" height="35px" width="192px" />
            <div className="col"  dangerouslySetInnerHTML={{__html: props.secondSectionText}}/>
            <div>&nbsp;</div>
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{ marginBottom: "6px" }}>
            <p>If you are a Sprint Customer, please "<span className="link-for-landing-page" role="link" onClick={ () => sprintSsoUrl(SIRIUSXM_PROMO_CODE)} tabIndex="0">click here to login</span>".</p>
            <p>If you are a T-Mobile for Business customer, please "<a href={process.env.REACT_APP_TMO_TFB_ID_AUTH_URL} rel="noreferrer">click here to login</a>".</p>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto" />
        </div>
        <div className="mx-auto col-md-5 text-center">
          <p>
            Questions before you continue?
            To find answers <a href="https://www.t-mobile.com/content/t-mobile/consumer/isp/FAQ.html" target="_blank" rel="noopener noreferrer">click here</a>.
            </p>          
        </div>
      </div>
    </section>
  )
}

